module.exports = __webpack_public_path__ + "static/media/speaker_PacificNorthwest_DrDragunaVrabie.e25ae3cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_PacificNorthwest_DrDragunaVrabie.jpg
// module id = 250
// module chunks = 0